<div
  class="image"
  #backgroundImage
  [style.background-image]="
    'linear-gradient(0deg, rgba(19, 21, 25, .5), rgba(19, 21, 25, .5)), url(' +
    currentImageUrl() +
    ')'
  "
></div>
